<script>
import MultiSelect from "vue-multiselect";

// Custom Components
import RoomLock from "@/components/lock/RoomLock.vue";
import DoorLock from "@/components/lock/DoorLock.vue";
import AssignLock from "@/components/lock/AssignLock.vue";
import roomService from "@/helpers/APIService/room.service";
import iotService from "@/helpers/APIService/iot.service";
import errorHandler from "@/helpers/errorHandler";
import middlewares from "@/helpers/middlewares";
import { socketConnect } from "@/helpers/webSocketHandler";
import { authComputed } from "@/state/helpers";

export default {
  data() {
    return {
      items: [
        {
          text: "room_lock",
        },
        {
          text: "door_log",
        },
        {
          text: "key_log",
        },
      ],
      encoderActions: ["disconnect", "reconnect", "read-card", "erase-card"],
      roomTypeOptions: [{ text: "All", value: "all" }],
      floorPlanOptions: [{ text: "All", value: "all" }],
      roomNumberOptions: [],
      roomLockList: [],
      isDataLoading: false,
      filter: {
        room_type: { text: "All", value: "all" },
        floor: { text: "All", value: "all" },
        room_number: { text: "All", value: "all" },
      },
      lockConnectedSocket: [],
      lockDeviceData: null,
      isShowStep: "room_lock",
      rfidEncoderList: [],
      isLoadinRFIDEncoder: false,
      requestSendFromEncoder: null,
      readKeyData: null,
      isShowReadKeyDataCount: 15,
      selectedFloorData: [],
      assignLockTitle: "Assign Lock",
      assignLockToRoom: null,
      assignLockIndex: 0,
    };
  },
  components: {
    MultiSelect,
    DoorLock,
    AssignLock,
    RoomLock,
  },
  computed: {
    ...authComputed,
    doorLockProps() {
      return {
        data: this.lockDeviceData,
        rfidEncoderList: this.rfidEncoderList.filter(
          (item) => item.isConnected
        ),
        gatewayWebSocketConnection: this.lockConnectedSocket.find(
          (gateway) =>
            gateway.id == this.lockDeviceData.lock_iot_device.iot_gateway
        ),
      };
    },
    assignLockProps() {
      return {
        assignLockToRoom: this.assignLockToRoom,
      };
    },
  },
  mounted() {
    this.getRoomLockListData();
    this.getRoomTypeList();
    this.getFloorList();
    this.connectWebSocket();
    this.getRFIDEncoderList();
    this.$root.$on("changeTokey", (data) => {
      this.isShowStep = data;
    });
    this.$root.$on("lock_assign", (data) => {
      this.getRoomLockListData();
    });
  },
  methods: {
    // Method is used to get all key list
    getKeyListData(query) {
      iotService
        .getKeyList(query)
        .then((response) => {
          this.keyList = response.results;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to get room type list
    getRoomTypeList() {
      roomService
        .getRoomTypeList()
        .then((response) => {
          response.map((item) => {
            this.roomTypeOptions.push({
              text: item.name,
              value: item.id,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to get room type list
    getFloorList() {
      roomService
        .getFloorList()
        .then((response) => {
          response.map((item) => {
            this.floorPlanOptions.push({
              text: item.name,
              value: item.id,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to get room lock list
    getRoomLockListData(query = "") {
      this.isDataLoading = true;
      roomService
        .getRoomList(query)
        .then((response) => {
          let tempBuildArr = response.reduce((r, a) => {
            r[
              JSON.stringify({
                id: a.building.id,
                name: a.building.name,
              })
            ] = [
              ...(r[
                JSON.stringify({
                  id: a.building.id,
                  name: a.building.name,
                })
              ] || []),
              a,
            ];
            return r;
          }, {});
          if (this.roomNumberOptions.length == 0) {
            this.roomNumberOptions.push({ text: "All", value: "all" });
            response.map((item) => {
              this.roomNumberOptions.push({
                text: item.room_number,
                value: item.room_number,
              });
            });
          }
          Object.keys(tempBuildArr).map((key) => {
            let obj = {};
            let floorTempArr = tempBuildArr[key].reduce((r, a) => {
              r[
                JSON.stringify({
                  id: a.floor.id,
                  name: a.floor.name,
                })
              ] = [
                ...(r[
                  JSON.stringify({
                    id: a.floor.id,
                    name: a.floor.name,
                  })
                ] || []),
                a,
              ];
              return r;
            }, {});
            obj[key] = floorTempArr;
            this.roomLockList = {
              ...this.roomLockList,
              ...obj,
            };
          });
          this.isDataLoading = false;
        })
        .catch((error) => {
          this.isDataLoading = false;
          errorHandler(error);
        });
    },
    // Method is used to connect websocket for room lock status
    connectWebSocket() {
      iotService
        .getLockGatewayList()
        .then((response) => {
          response.map((item) => {
            const webConnection = socketConnect(
              `iot/iot-gateway/${item.id}?token=${this.user.access}`
            );
            this.lockConnectedSocket.push({ conn: webConnection, ...item });
          });
          setTimeout(() => {
            this.watchWebSocket();
          }, 1500);
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to watch websocket
    watchWebSocket() {
      if (this.lockConnectedSocket.length !== 0) {
        this.lockConnectedSocket.map((gatewayConnection) => {
          gatewayConnection.conn.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.event_type == "device_event") {
              const selectedRoomIndex = this.selectedFloorData.findIndex(
                (lock) =>
                  lock.lock_iot_device !== null &&
                  lock.lock_iot_device.id == data.id
              );
              if (this.selectedFloorData[selectedRoomIndex] !== undefined) {
                this.selectedFloorData[selectedRoomIndex].lock_iot_device = {
                  ...this.selectedFloorData[selectedRoomIndex].lock_iot_device,
                  last_status: data.last_status,
                  config_data: data.config_data,
                };
                this.$set(
                  this.selectedFloorData,
                  data.id,
                  this.selectedFloorData[selectedRoomIndex]
                );
              }
            }
          };
        });
      }
    },
    // Method is used to filter room lock
    filterRoomLock(by) {
      let filter = "";
      if (by == "room_type") {
        if (this.filter.room_type.value !== "all") {
          filter += `?room_type=${this.filter.room_type.value}`;
        } else {
          this.getRoomLockListData();
        }
      }
      if (by == "floor_plan") {
        if (this.filter.floor.value !== "all") {
          filter += `?floor=${this.filter.floor.value}`;
        } else {
          this.getRoomLockListData();
        }
      }
      if (by == "search" && this.filter.room_number) {
        if (this.filter.room_number.value !== "all") {
          filter += `?search=${this.filter.room_number.value}`;
        } else {
          this.getRoomLockListData();
        }
      }
      if (filter !== "") {
        this.getRoomLockListData(filter);
      }
    },
    // Method is used to handle redirect
    redirecToKeyLog(data, redirect_to) {
      if (data.lock_iot_device !== null) {
        if (redirect_to == "door_log") {
          this.lockDeviceData = data;
          this.isShowStep = "door_log";
        }
      }
    },
    // Method is used to handle breadcrumb click
    handleBrdClick(brd) {
      this.$root.$emit("lockDataUpdate", brd);
      if (brd == "room_lock") {
        this.lockDeviceData = null;
        this.isShowStep = brd;
      }
      if (this.lockDeviceData !== null && brd == "door_log") {
        this.isShowStep = brd;
      }
    },
    // Method is used to selected floor
    selectedFloor(floor) {
      this.selectedFloorData = floor;
    },
    // Method is used to select build
    selectedBuilding(building) {
      this.selectedFloorData = building[Object.keys(building)[0]];
    },
    // Method is used to handle assign lock
    assingLock(data, index) {
      this.assignLockToRoom = data;
      this.assignLockIndex = index;
      this.$bvModal.show("assign-lock-modal");
      this.assignLockTitle = `Assign lock to Room No ${data.room_number}`;
    },
    // Method is used to get RFID Encoder list
    async getRFIDEncoderList() {
      try {
        this.isLoadinRFIDEncoder = true;
        const response = await iotService.getHotelRFIDEncoder();
        if (response) {
          response.map((encoder) => {
            let RFIDEncoderData = {
              ...encoder,
              isConnected: false,
              connectionStr: "",
            };
            const webConnection = socketConnect(
              `iot/rfid-encoder/${encoder.id}?token=${this.user.access}`
            );
            RFIDEncoderData.connectionStr = webConnection;
            webConnection.onopen = () => {
              console.log("encoder socket connected");
              webConnection.send(JSON.stringify({ cmd: "getstatus" }));
            };
            webConnection.onmessage = (event) => {
              const encoderWebSocketRes = JSON.parse(event.data);
              if (encoderWebSocketRes.command == "getstatus") {
                RFIDEncoderData.isConnected =
                  encoderWebSocketRes.cmdstatus == "success" ? true : false;
              }
              if (encoderWebSocketRes.command == "connectreader") {
                if (encoderWebSocketRes.cmdstatus == "success") {
                  RFIDEncoderData.isConnected =
                    encoderWebSocketRes.cmdstatus == "success" ? true : false;
                }
              }
              this.isLoadinRFIDEncoder = false;
            };
            this.rfidEncoderList.push(RFIDEncoderData);
          });
        }
      } catch (error) {
        this.isLoadinRFIDEncoder = false;
        errorHandler(error);
      }
    },
    // Watch Over RFID Encoder web socket
    watchRFIDEncoderSocket() {
      this.requestSendFromEncoder.connectionStr.onmessage = (event) => {
        if (event.readyState === 3) {
          this.requestSendFromEncoder.connectionStr = socketConnect(
            `iot/rfid-encoder/${this.requestSendFromEncoder.id}?token=${this.user.access}`
          );
        }
        const encoderWebSocketRes = JSON.parse(event.data);
        if (encoderWebSocketRes.cmdstatus == "error") {
          middlewares.notification(encoderWebSocketRes.cmdmsg, "danger", 3000);
        }
        if (encoderWebSocketRes.command == "getstatus") {
          middlewares.notification(
            encoderWebSocketRes.cmdmsg,
            encoderWebSocketRes.cmdstatus == "error" ? "danger" : "success",
            2000
          );
        }
        if (encoderWebSocketRes.command == "connectreader") {
          if (encoderWebSocketRes.cmdstatus == "success") {
            this.rfidEncoderList = this.rfidEncoderList.map((encoder) => {
              if (encoder.id == this.requestSendFromEncoder.id) {
                encoder.isConnected = true;
              }
              return encoder;
            });
            middlewares.notification(
              "Encoder successfully connected !!",
              "success",
              3000
            );
          }
        }
        if (encoderWebSocketRes.command == "disconnectreader") {
          if (encoderWebSocketRes.cmdstatus == "success") {
            this.rfidEncoderList = this.rfidEncoderList.map((encoder) => {
              if (encoder.id == this.requestSendFromEncoder.id) {
                encoder.isConnected = false;
              }
              return encoder;
            });
          }
          middlewares.notification(
            "Encoder successfully disconnected !!",
            "success",
            3000
          );
        }
        if (encoderWebSocketRes.command == "readcard") {
          if (encoderWebSocketRes.cmdstatus == "success") {
            if (encoderWebSocketRes.responsedata.card_id) {
              iotService
                .getKeyList(
                  `?and_rfid_card_id=${encoderWebSocketRes.responsedata.card_id}&and_is_active=1`
                )
                .then((response) => {
                  if (response.results.length !== 0) {
                    this.readKeyData = response.results[0];
                    this.readKeyData = {
                      "User Level Type": response.results[0].user_levey_type,
                      "Rfid Card Id": response.results[0].rfid_card_id,
                      "Start Date Time":
                        this.global_format_date_and_time_custom(
                          response.results[0].start_datetime,
                          "YYYY-MM-DD HH:mm"
                        ),
                      "Expire  Date Time":
                        this.global_format_date_and_time_custom(
                          response.results[0].expire_datetime,
                          "YYYY-MM-DD HH:mm"
                        ),
                      "Total Usage": response.results[0].total_usage,
                      "Last Use":
                        response.results[0].last_used_at !== null
                          ? this.global_format_date_and_time_custom(
                              response.results[0].last_used_at,
                              "YYYY-MM-DD HH:mm"
                            )
                          : "-",
                      "Deadbolt Enable": response.results[0].is_deadbolt_enable,
                      Status: response.results[0].is_active,
                      "Assigned To":
                        response.results[0].assigned_to !== null
                          ? response.results[0].assigned_to.first_name +
                            " " +
                            response.results[0].assigned_to.last_name
                          : "-",
                      Booking:
                        response.results[0].booking !== null
                          ? `${response.results[0].booking.first_name} ${response.results[0].booking.last_name} (${response.results[0].booking.reference_no})`
                          : "-",
                      "Created By": response.results[0].created_by,
                      "Updated By": response.results[0].updated_by,
                      "Created At": this.global_format_date_and_time_custom(
                        response.results[0].created_at,
                        "YYYY-MM-DD HH:mm"
                      ),
                      "Updated At": this.global_format_date_and_time_custom(
                        response.results[0].updated_at,
                        "YYYY-MM-DD HH:mm"
                      ),
                    };
                  } else {
                    this.readKeyData = encoderWebSocketRes.responsedata;
                  }
                });
            } else {
              this.readKeyData = encoderWebSocketRes.responsedata;
            }
          }
        }
        if (encoderWebSocketRes.command == "erasecard") {
          if (encoderWebSocketRes.cmdstatus == "success") {
            this.$bvModal.hide("read-key-modal");
            middlewares.notification(
              encoderWebSocketRes.cmdmsg,
              "success",
              3000
            );
          }
        }
      };
    },
    // Method is used to handle encoder action
    EncoderAction(proccessFor, data) {
      this.readKeyData = null;
      this.requestSendFromEncoder = null;
      this.isShowReadKeyDataCount = 15;
      this.isLoadinRFIDEncoder = true;
      this.requestSendFromEncoder = data;
      this.watchRFIDEncoderSocket();
      if (proccessFor == "connect") {
        data.connectionStr.send(
          JSON.stringify({
            cmd: "connectreader",
            port: data.com_port,
            baud: 115200,
          })
        );
      }
      if (proccessFor == "disconnect") {
        data.connectionStr.send(JSON.stringify({ cmd: "disconnectreader" }));
      }
      if (proccessFor == "reconnect") {
        data.connectionStr.send(JSON.stringify({ cmd: "reconnectreader" }));
      }
      if (proccessFor == "read-card") {
        data.connectionStr.send(JSON.stringify({ cmd: "readcard" }));
        this.$bvModal.show("read-key-modal");
        const intervalId = setInterval(() => {
          if (this.isShowReadKeyDataCount == 0) {
            clearInterval(intervalId);
          } else {
            this.isShowReadKeyDataCount--;
          }
        }, 1000);
      }
      if (proccessFor == "erase-card") {
        this.$bvModal.show("read-key-modal");
        const intervalId = setInterval(() => {
          if (this.isShowReadKeyDataCount == 0) {
            clearInterval(intervalId);
          } else {
            this.isShowReadKeyDataCount--;
          }
        }, 1000);
        data.connectionStr.send(JSON.stringify({ cmd: "erasecard" }));
      }
      setTimeout(() => {
        this.isLoadinRFIDEncoder = false;
      }, 2000);
    },
  },
};
</script>

<template>
  <div>
    <b-breadcrumb class="page-title-box font-size-16 px-0 pt-0 mb-0">
      <b-breadcrumb-item
        v-for="(bd, index) in items"
        :key="index"
        :active="isShowStep == bd.text ? false : true"
        @click="handleBrdClick(bd.text)"
        :class="isShowStep !== bd.text ? 'cursor' : ''"
      >
        <span class="text-capitalize"
          >{{ bd.text.replaceAll("_", " ") }}
          <span v-if="bd.text == 'door_log' && isShowStep == 'door_log'">
            ({{ lockDeviceData ? lockDeviceData.room_number : "" }})
          </span>
        </span>
      </b-breadcrumb-item>
    </b-breadcrumb>
    <div class="card" v-if="isShowStep == 'room_lock'">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-xl-2 col-md-4">
            <MultiSelect
              :options="roomTypeOptions"
              v-model="filter.room_type"
              :show-labels="false"
              :allow-empty="false"
              placeholder="by room type"
              track-by="value"
              label="text"
              name="room_type"
              @close="filterRoomLock('room_type')"
            />
          </div>
          <div class="col-xl-2 col-md-4">
            <MultiSelect
              :options="floorPlanOptions"
              :show-labels="false"
              :allow-empty="false"
              v-model="filter.floor"
              placeholder="by floor plan"
              track-by="value"
              label="text"
              name="floor_plan"
              @close="filterRoomLock('floor_plan')"
            />
          </div>
          <div class="col-xl-2 col-md-4">
            <MultiSelect
              :options="roomNumberOptions"
              v-model="filter.room_number"
              :show-labels="false"
              :allow-empty="false"
              placeholder="by room number"
              track-by="value"
              label="text"
              name="room_number"
              @close="filterRoomLock('search')"
            />
          </div>
          <div class="col-xl-4 offset-xl-2 text-end">
            <label class="text-end me-2">RFID Encoder</label>
            <b-dropdown
              class="me-2"
              right
              menu-class="dropdown-menu-end"
              v-for="encoder in rfidEncoderList"
              :key="encoder.id"
              :variant="
                encoder.isConnected ? 'outline-success' : 'outline-danger'
              "
            >
              <template v-slot:button-content>
                {{
                  `${encoder.mqtt_user}  ${
                    encoder.isConnected ? "Online" : "Offline"
                  }`
                }}
                <i
                  class="mdi mdi-spin mdi-loading ms-1"
                  v-if="
                    requestSendFromEncoder !== null
                      ? requestSendFromEncoder.id == encoder.id &&
                        isLoadinRFIDEncoder
                      : isLoadinRFIDEncoder
                  "
                ></i>
              </template>
              <div v-if="encoder.isConnected">
                <b-dropdown-item
                  class="text-capitalize"
                  v-for="(encoderA, index) in encoderActions"
                  :key="index"
                  @click="EncoderAction(encoderA, encoder)"
                  >{{ encoderA.replaceAll("-", " ") }}</b-dropdown-item
                >
              </div>
              <div v-else>
                <b-dropdown-item @click="EncoderAction('connect', encoder)"
                  >Connect</b-dropdown-item
                >
              </div>
            </b-dropdown>
            (<i class="fas fa-info" id="popover-3"></i>)
            <b-popover target="popover-3" triggers="hover focus">
              <template #title>Lock Status</template>
              <div class="p-2">
                <i class="fas fa-battery-half text-success fs-5 me-2"></i>
                <span> Battery Status</span>
                <br />
                <i class="mdi mdi-lock-outline text-success fs-5 me-2"></i>
                <span>Latch Off</span>
                <br />
                <i
                  class="mdi mdi-lock-open-variant-outline text-success fs-5 me-2"
                >
                </i>
                <span> Latch on</span>
                <br />
                <i class="mdi mdi-lock-outline text-danger fs-5 me-2"> </i>
                <span> Door has DeadLock </span>
                <br />
                <i class="mdi mdi-lock-outline text-success fs-5 me-2"> </i>
                <span> Door is not DeadLocked </span>
                <br />
                <p class="mb-0">
                  - Room no. <span class="text-success">Green</span> (Lock
                  Online)
                </p>
                <p class="mb-0">
                  - Room no. <span class="text-danger">Red</span> (Lock Offline)
                </p>
              </div>
            </b-popover>
          </div>
        </div>

        <div class="d-flex flex-wrap" v-if="isDataLoading">
          <div v-for="lock in 24" :key="lock">
            <div class="card lock-box placeholder-glow">
              <div
                class="d-flex align-items-center justify-content-between placeholder placeholder-lg"
              >
                <div class="d-flex align-items-center">
                  <i class="fas fa-battery-full text-secondary fs-4 me-2"></i>
                  <span class="text-secondary">100%</span>
                </div>
                <i class="bx bx-lock fs-4 text-secondary"></i>
              </div>
              <div
                class="lock-box-text d-flex align-items-center justify-content-center placeholder placeholder-lg"
              >
                <h2 class="mb-0">***</h2>
              </div>
              <i
                class="fas fa-bed d-block text-center fs-3 placeholder placeholder-lg"
              ></i>
            </div>
          </div>
        </div>
        <template v-else>
          <b-card
            no-body
            class="shadow-none"
            v-for="(building, index) in roomLockList"
            :key="index"
          >
            <b-card-header
              header-tag="header"
              role="tab"
              @click="selectedBuilding(building)"
            >
              <h5 slot="header" class="my-1" v-b-toggle="JSON.parse(index).id">
                {{ JSON.parse(index).name }}
              </h5>
            </b-card-header>
            <b-collapse
              :id="JSON.parse(index).id"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-tabs
                justified
                nav-class="nav-tabs-custom"
                content-class="p-2 text-muted"
              >
                <b-tab
                  v-for="(floor, fIndex) in building"
                  :key="fIndex"
                  :active="assignLockIndex == fIndex ? true : false"
                  @click="selectedFloor(floor)"
                >
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <h5 class="d-none d-sm-inline-block">
                      {{ JSON.parse(fIndex).name }}
                    </h5>
                  </template>
                  <div class="d-flex flex-wrap">
                    <div
                      v-for="(lock, lIndex) in selectedFloorData"
                      :key="lIndex"
                    >
                      <RoomLock
                        :lock="lock"
                        :fIndex="fIndex"
                        @assing-lock="assingLock(lock, index)"
                        @redirect-to-keylog="redirecToKeyLog(lock, 'door_log')"
                      />
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-collapse>
          </b-card>
        </template>
      </div>
    </div>
    <!-- DoorLock log -->
    <DoorLock v-if="isShowStep !== 'room_lock'" :currentProps="doorLockProps" />
    <!-- Model is for assing and remove lock -->
    <b-modal
      id="assign-lock-modal"
      :title="assignLockTitle"
      centered
      hide-footer
      size="xl"
    >
      <div>
        <AssignLock :current-props="assignLockProps" />
      </div>
    </b-modal>
    <!-- Model is used to display RFID data -->
    <b-modal id="read-key-modal" title="Read Key Data" centered hide-footer>
      <div class="row" v-if="readKeyData !== null">
        <div
          class="col-md-6"
          v-for="(item, key, index) in readKeyData"
          :key="index"
        >
          <h5 class="font-size-14 text-capitalize">
            {{
              key == "startdate"
                ? "Start Date"
                : key == "enddate"
                ? "End Date"
                : key.replaceAll("_", " ")
            }}
          </h5>
          <p>
            {{
              key == "startdate" || key == "enddate"
                ? item.replaceAll("+00:00", "")
                : item
            }}
          </p>
        </div>
      </div>
      <div v-if="readKeyData == null && isShowReadKeyDataCount !== 0">
        <img
          src="@/assets/images/rfid.gif"
          alt="rfid animation"
          class="w-75 d-block mx-auto"
        />
        <h5 class="text-center">
          Place your card (<strong> {{ isShowReadKeyDataCount }}</strong> )
        </h5>
      </div>
      <div
        v-if="readKeyData == null && isShowReadKeyDataCount == 0"
        class="text-center"
      >
        <img src="@/assets/images/canceled.gif" class="w-50" alt="" />
        <h6 class="mt-3">
          <span class="text-danger">We are not able to process</span>
        </h6>
        <p class="text-info cursor">Please try again.</p>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.lock-box {
  width: 200px;
  min-height: 172px;
  padding: 14px;
  border-radius: 6px;
  margin: 10px;
}
.lock-box-text {
  min-height: 100px;
}
.lock-box-text h2 {
  font-size: 30px;
}
.room-search i {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
</style>
